
const White = '#fff';
const Black = '#000';

const PrimaryColor = '#C8A237';
const PrimaryDarkColor = '#B89227';

const TextColor = '#000';
const TextGray = '#AAAAAA';

const BackHeroColor = '#DADADB';
const GrayBack = '#F7F7F7';

export {
  BackHeroColor,
  Black,
  GrayBack,
  PrimaryColor,
  PrimaryDarkColor,
  TextColor,
  TextGray,
  White,
};



// WEBPACK FOOTER //
// ./src/components/styles/colors.js